import React, { PureComponent } from 'react'
import { DsStack, DsTypography } from '@am92/react-design-system'

import getWithPageConstants, {
  IWithPageConstantsProps
} from '~/src/Hocs/withPageConstants'

import FaqCategory from './Components/FaqCategory'
import PageWrapper from '~/src/Components/PageWrapper'

import FAQ_PAGE_CONSTANTS from './FAQ.PageConstants'
import { T_FAQ_PAGE_CONSTANTS } from './FAQ.PageConstants/TYPES'

export interface ITermsAndConditionsgPageProps
  extends IWithPageConstantsProps<T_FAQ_PAGE_CONSTANTS> {}

class TermsAndConditionsgPage extends PureComponent<ITermsAndConditionsgPageProps> {
  render() {
    const { PAGE_CONSTANTS } = this.props
    return (
      <PageWrapper>
        <DsStack alignItems='center' spacing='var(--ds-spacing-frostbite)'>
          <DsTypography variant='subheadingSemiboldLarge' textAlign='center'>
            {PAGE_CONSTANTS.PAGE_KICKER}
          </DsTypography>
          <DsTypography variant='displayBoldMedium' textAlign='center'>
            {PAGE_CONSTANTS.PAGE_TITLE}
          </DsTypography>
        </DsStack>

        <DsStack
          direction='column'
          spacing={{
            xs: 'var(--ds-spacing-mild)',
            md: 'var(--ds-spacing-hot)'
          }}
          sx={{
            px: { md: '15%' }
          }}
        >
          {PAGE_CONSTANTS.FAQ_CATEGORIES.map(
            (faqCategory, faqCategoryIndex) => (
              <FaqCategory key={faqCategoryIndex} faqCategory={faqCategory} />
            )
          )}
        </DsStack>
      </PageWrapper>
    )
  }
}

const withPageConstants =
  getWithPageConstants<T_FAQ_PAGE_CONSTANTS>(FAQ_PAGE_CONSTANTS)

export default withPageConstants(TermsAndConditionsgPage)
